/**
 * The last part of a public site address (`/venues/<name>`): lowercase words
 * joined by single hyphens (docs/public-site.spec.md). Never an id, which is how
 * the app's own pages under the same sections (`/venues/<id>/…`) stay the app's,
 * and never one of the app's words there.
 */
const PAGE_NAME = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

/** An id as the app puts one in an address. */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * Words under the site's sections that no page can be named: the app's
 * `/venues/all`, `/vendors/new` from before it moved, and the site's own
 * `/vendors/all`, the directory of vendors (a page of its own in `SITE_PAGES`).
 */
export const APP_WORDS = ['all', 'new'] as const

export function isUuid(segment: string): boolean {
  return UUID.test(segment)
}

/** A page name the site can answer to. */
export function isPageName(segment: string): boolean {
  return PAGE_NAME.test(segment) && !isUuid(segment) && !APP_WORDS.some((word) => word === segment)
}
